import styled from 'styled-components';

import LoadingAnimation from 'components/loading-animation';
import { LoyaltyBackground } from 'pages/loyalty/loyalty-background';

export const Container = styled.div`
  margin: 2rem auto;
  width: 90%;
  display: flex;
  flex-direction: column;
  text-align: center;

  ${Styles.desktop`
    margin: ${Styles.layout.navHeight.desktop} auto;
    max-width: ${Styles.layout.smallerSectionMaxWidth};
  `}
`;

export const Loading = styled(LoadingAnimation)`
  min-height: calc(100vh - 107px);
`;

export const BackgroundContainer = LoyaltyBackground;
